import { z } from "zod";
import { zObjectId, zServiceProject } from "@dobrh-monorepo/core";
import { HttpMethodEnum, HttpParamsTypeEnum, Route } from "../../../../utils/route";

const requestSchema = z.object({
  serviceProjectId: zObjectId(),
  deliverables: z.array(
    z.object({
      id: zObjectId(),
      isCompleted: z.boolean(),
    }),
  ),
});

const responseSchema = zServiceProject;

export default {
  method: HttpMethodEnum.POST,
  paramsType: HttpParamsTypeEnum.BODY,
  requestZodSchema: requestSchema,
  responseZodSchema: responseSchema,
} satisfies Route;
